import { createFileRoute } from "@tanstack/react-router";
import Workspace from "@/bench/Workspace";
export const Route = createFileRoute("/")({ component: Workspace });
